<template>
  <div id="th-loading">
    <div id="th-spinner" />
  </div>
</template>

<script>
import { getToken } from '@josempgon/vue-keycloak'

export default {
  name: 'Broadcast2FA',

  created() {
    this.handlePopupMessage()
  },

  methods: {
    async handlePopupMessage() {
      // Create broadcast channel for cross-tab communication
      const broadcastChannel = new BroadcastChannel('keycloak_auth_channel')
      broadcastChannel.postMessage({
        type: 'keycloak_auth_success',
        token: await getToken()
      })
      broadcastChannel.close()
      window.close()
    }
  }
}
</script>
